// extracted by mini-css-extract-plugin
export default {"DashboardWrapper":"Dashboard_DashboardWrapper__3eYNA","Loading":"Dashboard_Loading__m0jZF","main-panel":"Dashboard_main-panel__6oPHG"};